module.exports = __webpack_public_path__ + "img/peoployed.f90dc82d.png";